import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
    name: 'serviceTypeCreate',
    initialState: {
        error: null,
        loading: false,
        name: '',
        shouldRedirect: false
    },
    reducers: {
        setError: (state, action) => {
            state.error = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setName: (state, action) => {
            state.name = action.payload.value;
        },
        setShouldRedirect: (state, action) => {
            state.shouldRedirect = action.payload;
        }
    }
});

export const {
    setError,
    setLoading,
    setName,
    setShouldRedirect
} = slice.actions;
export const serviceTypeCreateReducer = slice.reducer;